import type { FlagState } from '../types';
import { stateSchema } from '../types';

export function assertFlagState(name: unknown): asserts name is FlagState {
  stateSchema.parse(name);
}
